// removed by extract-text-webpack-plugin
module.exports = {"root":"_2wxOe","inverted":"_2XbuM"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/brand/Logo/index.sass
// module id = ./src/elements/brand/Logo/index.sass
// module chunks = 6